import React from "react";
import Reveal from "@/components/Reveal";

export const PageHero = ({ eyebrow, title, subtitle, image, rightSlot }) => (
  <section className="bg-white border-b border-[#EAEAEA]" data-testid="page-hero">
    <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
      <Reveal className="lg:col-span-7">
        <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
          {eyebrow}
        </div>
        <h1 className="mt-4 font-display text-[42px] md:text-[64px] leading-[1.02] font-black tracking-tight text-[#0F1115]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-[17px] md:text-[19px] leading-relaxed text-[#1C1F26] max-w-xl">
            {subtitle}
          </p>
        )}
      </Reveal>

      {(image || rightSlot) && (
        <Reveal className="lg:col-span-5" delay={120}>
          {rightSlot ? (
            rightSlot
          ) : (
            <div className="relative">
              <div className="absolute -top-4 -right-4 w-28 h-28 rounded-full bg-[#FDD805]" aria-hidden />
              <div className="relative rounded-3xl overflow-hidden border border-[#EAEAEA]">
                <img src={image} alt="" className="w-full h-[320px] object-cover" />
              </div>
            </div>
          )}
        </Reveal>
      )}
    </div>
  </section>
);

export default PageHero;
